<template>
  <card
    v-if="!isLoadingImages && !isLoadingVideos && hasCorrectAmbito"
    :style="[
      isLarge
        ? {
            'max-width': '28rem',
            height: '48rem',
            'max-height': '48rem',
            'border-radius': '10px',
          }
        : {
            'max-width': '28rem',
            height: '49rem',
            'max-height': '60rem',
            'border-radius': '10px',
          },
    ]"
    class="postcardattivita attivita orange p-0 card-body"
    :class="isLarge ? 'mx-2' : ''"
  >
    <div>
      <slider
        class="custom-image-slider"
        animation="fade"
        :autoplay="false"
        v-if="item.media !== undefined && item.media.length !== 0"
      >
        <slider-item v-for="(media, index) in item.media" :key="index">
          <img
            v-img="{ group: screenSize + indexOfActivity }"
            :src="media['o:thumbnail_urls']['large']"
            :alt="item['o:title']"
            class="img"
          />
        </slider-item>
      </slider>
      <slider
        class="custom-image-slider"
        animation="fade"
        :autoplay="false"
        v-else
      >
        <slider-item>
          <img
            v-img="{ group: screenSize + indexOfActivity }"
            :src="require('@/assets/images/noPhotoAvailable.png')"
            alt="Esperimento"
            class="img"
          />
        </slider-item>
      </slider>

      <div class="m-4">
        <h5 class="card-title text-center">
          <b>{{ item["o:title"] }}</b>
        </h5>

        <div
          :class="
            isLarge
              ? 'postcardattivita__tagbox mb-4'
              : 'postcardattivita__tagbox mb-4'
          "
        >
          <button
            :class="
              selectedTab === 'Panoramica'
                ? 'tag__item__selected'
                : 'tag__item__unselected'
            "
            v-on:click="selectedTab = 'Panoramica'"
          >
            Panoramica
          </button>
          <button
            :class="
              selectedTab === 'Descrizione'
                ? 'tag__item__selected'
                : 'tag__item__unselected'
            "
            v-on:click="selectedTab = 'Descrizione'"
          >
            Descrizione
          </button>
          <!-- <button
            :class="
              selectedTab === 'Immagini'
                ? 'tag__item__selected'
                : 'tag__item__unselected'
            "
            v-on:click="selectedTab = 'Immagini'"
          >
            Immagini
          </button> -->
          <button
            :class="
              selectedTab === 'Video'
                ? 'tag__item__selected'
                : 'tag__item__unselected'
            "
            v-on:click="selectedTab = 'Video'"
          >
            Video
          </button>
        </div>

        <div :class="{ 'text-justify ': !isMobile }">
          <div v-if="selectedTab === 'Panoramica'" class="col-12 px-0">
            <div
              class="text-left px-0 px-lg-3 col-12 text-black text mt-3"
              style="overflow: visible; text-overflow: ellipsis"
            >
              <div>
                <div class="row text-center">
                  <div class="col-6" style="border-right: 1px ridge">
                    <div class="row text-center">
                      <div class="col-12">
                        <i class="bi bi-pin-map-fill mr-2"></i>
                      </div>
                    </div>
                    <div class="row text-center">
                      <div class="col-12">
                        <h5 style="font-weight: 600">
                          {{
                            item["geo:situato_in"][0][
                              "display_title"
                            ].substring(6)
                          }}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="row text-center">
                      <div class="col-12">
                        <i class="bi bi-clock mr-2"></i>
                      </div>
                    </div>
                    <div class="row text-center">
                      <div class="col-12">
                        <h5 style="font-weight: 600">
                          {{ item["geo:Durata"][0]["@value"] }} minuti
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mx-1 mb-2 mt-4" v-if="!isGeodidalab">
                  <h6 class="mr-2">Ambito:</h6>
                  <h6 class="font-weight-normal">
                    {{ item["geo:appartiene_a_ambito"][0]["display_title"] }}
                  </h6>
                </div>

                <div
                  class="row mx-1 mb-2 mt-4"
                  :class="isGeodidalab ? 'mt-4' : ''"
                  v-if="
                    isGeodidalab &&
                    item['geo:ha_difficolta'] !== undefined &&
                    item['geo:ha_difficolta'].length > 0
                  "
                >
                  <h6 class="mr-2">Difficoltà:</h6>
                  <h6
                    class="font-weight-normal"
                    v-if="
                      item['geo:ha_difficolta'][0]['display_title'] ===
                      'Per Tutti'
                    "
                  >
                    {{ item["geo:ha_difficolta"][0]["display_title"] }}
                  </h6>
                  <h6 class="font-weight-normal" v-else>
                    da {{ item["geo:ha_difficolta"][0]["display_title"] }} in sù
                  </h6>
                </div>
                <div
                  class="row mx-1 mb-2"
                  v-if="
                    isGeodidalab &&
                    item['geo:ha_interesse'] !== undefined &&
                    item['geo:ha_interesse'].length > 0
                  "
                >
                  <h6 class="mr-2">
                    <template
                      v-if="
                        getInterestList(item['geo:ha_interesse']).length > 1
                      "
                      >Interessi:
                    </template>
                    <template v-else>Interesse: </template>
                    <span class="font-weight-normal">{{
                      getInterestList(item["geo:ha_interesse"]).join(", ")
                    }}</span>
                  </h6>
                </div>
                <!-- <div class="row mx-1 mb-2">
                  <h6 class="mr-2">Durata:</h6>
                  <h6 class="font-weight-normal">
                    {{ item["geo:Durata"][0]["@value"] }} minuti
                    <i class="bi bi-clock mr-2"></i>
                  </h6>
                </div>
                <div class="row mx-1 mb-2">
                  <h6 class="mr-2">Location:</h6>
                  <h6 class="font-weight-normal">
                    {{
                      item["geo:situato_in"][0]["display_title"].substring(6)
                    }}
                    <i class="bi bi-pin-map-fill mr-2"></i>
                  </h6>
                </div> -->
                <div class="row mx-1 mb-2">
                  <h6 class="mr-2">
                    Strumenti usati:
                    <span class="font-weight-normal">{{
                      getToolsList(item["geo:usa_strumento"]).join(", ")
                    }}</span>
                  </h6>
                </div>
                <div class="row mx-1 mb-2">
                  <h6 class="mr-2">Tipologia:</h6>
                  <h6
                    class="font-weight-normal"
                    v-if="item['geo:ha_tipologia_attivita']"
                  >
                    {{ item["geo:ha_tipologia_attivita"][0]["display_title"] }}
                  </h6>
                  <h6 class="font-weight-normal" v-else>Non disponibile</h6>
                </div>
              </div>
            </div>
          </div>
          <div v-else-if="selectedTab === 'Descrizione'" class="col-12">
            <div
              class="text-justify px-0 px-lg-3 description col-12 text-black text mt-3"
              style="overflow: auto"
            >
              <div>
                <b>{{ item["dcterms:description"][0]["@value"] }}</b>
              </div>
            </div>
          </div>
          <!-- <div
            v-else-if="selectedTab === 'Immagini'"
            class="col-12 px-0 text-center pb-3"
          >
            <slider
              animation="fade"
              :autoplay="false"
              v-if="item.media !== undefined && item.media.length !== 0"
            >
              <slider-item v-for="(media, index) in item.media" :key="index">
                <img
                  v-img="{ group: 'desktopTabImage' + indexOfActivity }"
                  :src="media['o:thumbnail_urls']['large']"
                  :alt="item['o:title']"
                  class="img"
                />
              </slider-item>
            </slider>

            <div
              v-if="item.media === undefined || item.media.length === 0"
              class="mt-3 text-black"
            >
              Non sono presenti immagini
            </div>
          </div> -->
          <div
            v-else-if="selectedTab === 'Video'"
            class="col-12 px-0 text-center pb-3"
          >
            <slider
              style="height: 250px"
              animation="fade"
              :autoplay="false"
              v-if="item.mediaYT !== undefined && item.mediaYT.length !== 0"
            >
              <slider-item v-for="(media, index) in item.mediaYT" :key="index">
                <div>
                  <iframe
                    class="embed-responsive-item"
                    frameborder="0"
                    :src="videoSource()"
                    allowfullscreen
                    style="
                      overflow: hidden;
                      overflow-x: hidden;
                      overflow-y: hidden;
                      height: 100%;
                      width: 100%;
                      position: absolute;
                      top: 0px;
                      left: 0px;
                      right: 0px;
                      bottom: 0px;
                      border-radius: 10px;
                      margin-y: auto;
                    "
                    height="100%"
                    width="100%"
                  ></iframe>
                </div>
              </slider-item>
            </slider>

            <div
              v-if="item.mediaYT === undefined || item.mediaYT.length === 0"
              class="mt-3 text-black"
            >
              Non sono presenti video
            </div>
          </div>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
const Common = require("@/Common.vue").default;

import $ from "jquery";
import Card from "../Cards/Card.vue";

import { isMobile } from "mobile-device-detect";
import { config } from "../../utils/config";

import { Slider, SliderItem } from "vue-easy-slider";

export default {
  name: "esperimento",
  props: ["item", "indexOfActivity", "hasCorrectAmbito", "screenSize"],

  components: {
    Card,
    Slider,
    SliderItem,
  },

  data() {
    return {
      selectedTab: "Panoramica",
      windowWidth: 0,
      isLoadingImages: true,
      isLoadingVideos: true,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      isMobile: false,
      isGeodidalab: false,
    };
  },
  created() {
    this.windowWidth = $(window).width();

    $(window).resize(() => {
      this.windowWidth = $(window).width();
    });

    this.isGeodidalab = config.isGeodidalab;
  },

  methods: {
    videoSource: function () {
      if (this.item["mediaYT"][0]["o:source"].includes("youtu.be/"))
        return (
          "https://youtube.com/embed/" +
          this.item["mediaYT"][0]["o:source"].split("/").pop() +
          "?modestbranding=1&playsinline=1&rel=0"
        );
      else
        return (
          "https://youtube.com/embed/" +
          this.item["mediaYT"][0]["o:source"].split("/watch?v=").pop() +
          "?modestbranding=1&playsinline=1&rel=0"
        );
    },
    getInterestList(list) {
      var newList = [];

      for (var i = 0; i < list.length; i++) {
        newList.push(list[i]["display_title"].toUpperCase());
      }

      if (newList === []) {
        newList.push("NESSUNO");
      }

      return newList;
    },
    getToolsList(list) {
      var newList = [];

      for (var i = 0; i < list.length; i++) {
        newList.push(list[i]["display_title"].toUpperCase());
      }

      if (newList === []) {
        newList.push("Nessuno");
      }

      return newList;
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    player() {
      return this.$refs.youtube.player;
    },
    isLarge() {
      return this.windowWidth >= 768;
    },
    getYoutubeVideoID() {
      var url = this.item["mediaYT"][0]["o:source"];
      return url.substring(url.indexOf("=") + 1);
    },
  },

  mounted() {
    this.isMobile = isMobile;

    var self = this;

    Common.getElementImages(this, this.item, (mediaList) => {
      this.item.media = mediaList;
      self.isLoadingImages = false;
    });

    Common.getElementYTVideos(this, this.item, (ytVideoList) => {
      this.item.mediaYT = ytVideoList;
      self.isLoadingVideos = false;
    });
  },
};
</script>

<style lang="scss">
.img {
  align-items: center;
  height: 100%;
  object-fit: cover;
  border-radius: 10px 10px 0px 0px;
}

.text {
  height: 15rem;
  overflow: scroll;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.card-body {
  padding: 0 !important;
}

.custom-image-slider {
  height: 270px !important;
}

.slider-indicator-icon {
  background-color: rgba(0, 0, 0, 0.458) !important;
}

.slider-indicator-active {
  background-color: white !important;
}
</style>